import { Component } from '@angular/core';

import { BsModalService } from 'ngx-bootstrap/modal';

import { Globals } from 'app/_models/globals';

import { GeneralService } from 'app/_services/general.service';
import { NotificationService } from 'app/_services/notification.service';

import { SupportAdicionarComplementoComponent } from 'app/support/_componentes/adicionar-complemento/adicionar-complemento.component';
import { UntypedFormBuilder } from '@angular/forms';
import { SupportCotacoesService } from 'app/support/cotacoes/cotacoes.service';
import { AccountService } from 'app/account/account.service';

@Component({
    selector: 'app-adicionar-complemento', templateUrl: '../../../support/_componentes/adicionar-complemento/adicionar-complemento.component.html', styleUrls: ['../../../support/_componentes/adicionar-complemento/adicionar-complemento.component.scss'],
    standalone: false
})
export class BuyerAdicionarComplementoComponent extends SupportAdicionarComplementoComponent {
    constructor(protected generalService: GeneralService, protected notificationService: NotificationService, protected accountService: AccountService, protected supportCotacoesService: SupportCotacoesService, protected globals: Globals,
        protected modalService: BsModalService, protected fb: UntypedFormBuilder)
    {
        super(generalService, notificationService, accountService, supportCotacoesService, globals, modalService, fb);
    }
}
